import { customElement, property, state } from "lit/decorators.js";
import { BaseComponent } from "../../base-component/base-component";
import { html, nothing } from "lit";
import { WishList } from "../interfaces/wish-list-items.interface";
import { handleOptionDownload } from "../../product-catalog-download/utils/downloader.util";
import { DownloadType } from "../../../common/utils/downloader/interfaces/downloader.interface";
import store from "../../../store/store";
import { connect } from "pwa-helpers";
import { StoreState } from "../../../store/store.interface";
import { selectUser } from "../../user-profile/user-profile.selectors";
import { UserProfile } from "../../user-profile/user-profile.interface";
import { mapWishListItemsToProducts } from "../utils/wish-list-product.util";
import { PDF_MAP, csvXlsxHeaders, productFields, wishListItemPdfHeader } from "../utils/wish-list-downloader.util";
import { WishListOptionsAnalytics } from "../utils/wish-list-options.analytics";

const buttonDisplayOptions = [
  {
    id: "wish-list-radio-pdf-button",
    label: "as .PDF",
    option: DownloadType.PDF,
  },
  {
    id: "wish-list-radio-csv-button",
    label: "as .CSV",
    option: DownloadType.CSV,
  },
  {
    id: "wish-list-radio-xlsx-button",
    label: "as .XLSX",
    option: DownloadType.XLSX,
  }
];

@customElement('mhecomm-download-wish-list')
export class DownloadWishList extends connect(store)(BaseComponent) {

  @property({ type: String })
  offCanvasId;

  @property({type: Object})
  wishList?: WishList;

  @state()
  isDownloadEnabled = false;

  @state()
  selectedOption = '';

  @state()
  private user: UserProfile | undefined;

  private analytics: WishListOptionsAnalytics;
  private downloadOptionSelected;

  constructor() {
    super();
    this.analytics = new WishListOptionsAnalytics();
  }

  async stateChanged(state: StoreState) {
    this.user = selectUser(state);
  }

  renderComp() {
    if (!this.wishList) {
      return nothing;
    }

    return html`
      <div class="mb-3">
        ${buttonDisplayOptions.map(
          (displayOption, index) => {
            return html`
              <div class="form-check">
                <input 
                  class="form-check-input" 
                  type="radio" 
                  name="download-options" 
                  id="${displayOption.id}"
                  @change=${() => this.onOptionSelected(displayOption.option)}
                >
                <label class="form-check-label" for="download-options${index}">
                  ${displayOption.label}
                </label>
              </div>
            `
          }
        )}
      </div>
      <div class="d-flex flex-column border-top">
        <button 
          class="btn btn-primary" 
          id="downloadWishListOptionsBtn"
          @click=${this.onClickDownloadWishList} 
          data-automation-id="download-wish-list-options-btn"
          ?disabled="${!this.isDownloadEnabled}"
        >
          Download
        </button>
      </div>
    `;
  }

  private onOptionSelected(option: string): void {
    this.downloadOptionSelected = option;
    // to trigger the event listener
    this.analytics.optionSelection(
      'wish-list',
      this,
      option,
      this.wishList,
      this.offCanvasId
    );
    // to emit event and push to datalayer
    this.analytics.optionSelectionEvent(
      'wish-list',
      this,
      option,
      this.wishList
    );

    this.selectedOption = option;
    this.isDownloadEnabled = true;
  }

  private onClickDownloadWishList(): void {
    this.analytics.offCanvasOptionSelection(
      'download',
      this,
      this.wishList!,
      this.wishList?.wishlist_id!,
      this.downloadOptionSelected,
    );

    if (this.selectedOption) {
      handleOptionDownload(
        PDF_MAP[this.selectedOption],
        this.wishList?.name!,
        wishListItemPdfHeader(this.wishList!),
        csvXlsxHeaders,
        productFields,
        mapWishListItemsToProducts(this.wishList?.wishlist_items!, `${this.user?.givenName} ${this.user?.familyName}`),
        true
      );
    }
  }

}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-download-wish-list': DownloadWishList;
  }
}
